<!-- <lib-ph-bhp-forget-password></lib-ph-bhp-forget-password>  -->
<lib-ph-bhp-reset-password [validationKey]="validationKey" [languageCode]="languageCode" (childData)="onSubmitSuccess($event)"></lib-ph-bhp-reset-password>